'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tab;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tab(_ref) {
  var match = _ref.match,
      label = _ref.label,
      onClick = _ref.onClick,
      selected = _ref.selected;

  var className = ['job_match_tab', selected ? 'active' : null].join(' ');

  var matchSafe = isNaN(match) ? 0 : match;

  return _react2.default.createElement(
    'li',
    {
      className: className,
      onClick: onClick
    },
    _react2.default.createElement(
      'a',
      null,
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'match' },
          Math.round(matchSafe * 100),
          '%'
        ),
        _react2.default.createElement('br', null),
        label,
        _react2.default.createElement('br', null),
        _react2.default.createElement('strong', null)
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobMatch/Tabs/Tab.jsx
// module id = 1200
// module chunks = 0